import getLeftCharmsContainerWidth from "./getLeftCharmsContainerWidth";

/**
 * Gets the style for the left charms container.
 * @param searchAlignmentWidth - The width of the search alignment container.
 * @returns The style for the left charms container.
 */
export default function getLeftCharmsContainerStyle(searchAlignmentWidth?: number): React.CSSProperties | undefined {
    return searchAlignmentWidth
        ? ({
            "--header-left-charms-width": `${getLeftCharmsContainerWidth(searchAlignmentWidth)}px`,
        } as React.CSSProperties)
        : undefined;
}
